import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAdminAuthed } from "../auth/auth.storage";

const RequireAdmin = () => {
  const location = useLocation();
  if (!isAdminAuthed()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
};

export default RequireAdmin;

